/*
 * Sound-icon segment living inside the clock pill, to the right of the time.
 * Stretches to the pill height; its top-right corner matches the pill so the
 * hover wash respects the rounded corner.
 */
.button {
  align-self: stretch;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px 0 12px;
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
  border-radius: 0 24px 0 0;
  transition: background 120ms ease;
}

.button:hover {
  background: rgba(255, 255, 255, 0.22);
}

.button:active {
  background: rgba(255, 255, 255, 0.3);
}
